import { render, staticRenderFns } from "./SyncHistory.vue?vue&type=template&id=949c1148"
import script from "./SyncHistory.vue?vue&type=script&lang=js"
export * from "./SyncHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports